export default {
  /**
   * 获取当前时间戳
   */
  time() {
    return Math.round(new Date() / 1000)
  },
  
  /**
   * 求百分比
   */
  GetPercent(num, total) {
    num = parseFloat(num)
    total = parseFloat(total)
    if (isNaN(num) || isNaN(total)) {
      return "-"
    }
    return total <= 0 ? "" : (Math.round(num / total * 10000) / 100.00)
  },
  
  $h: {
    // 除法函数
    Div: function(arg1, arg2) {
      arg1 = parseFloat(arg1)
      arg2 = parseFloat(arg2)
      var t1 = 0, t2 = 0, r1, r2
      try { t1 = arg1.toString().split(".")[1].length } catch (e) {}
      try { t2 = arg2.toString().split(".")[1].length } catch (e) {}
      r1 = Number(arg1.toString().replace(".", ""))
      r2 = Number(arg2.toString().replace(".", ""))
      return this.Mul(r1 / r2, Math.pow(10, t2 - t1))
    },
    
    // 加法函数
    Add: function(arg1, arg2) {
      arg2 = parseFloat(arg2)
      var r1, r2, m
      try { r1 = arg1.toString().split(".")[1].length } catch (e) { r1 = 0 }
      try { r2 = arg2.toString().split(".")[1].length } catch (e) { r2 = 0 }
      m = Math.pow(100, Math.max(r1, r2))
      return (this.Mul(arg1, m) + this.Mul(arg2, m)) / m
    },
    
    // 减法函数
    Sub: function(arg1, arg2) {
      arg1 = parseFloat(arg1)
      arg2 = parseFloat(arg2)
      var r1, r2, m, n
      try { r1 = arg1.toString().split(".")[1].length } catch (e) { r1 = 0 }
      try { r2 = arg2.toString().split(".")[1].length } catch (e) { r2 = 0 }
      m = Math.pow(10, Math.max(r1, r2))
      n = (r1 >= r2) ? r1 : r2
      return ((this.Mul(arg1, m) - this.Mul(arg2, m)) / m).toFixed(n)
    },
    
    // 乘法函数
    Mul: function(arg1, arg2) {
      arg1 = parseFloat(arg1)
      arg2 = parseFloat(arg2)
      var m = 0, s1 = arg1.toString(), s2 = arg2.toString()
      try { m += s1.split(".")[1].length } catch (e) {}
      try { m += s2.split(".")[1].length } catch (e) {}
      return Number(s1.replace(".", "")) * Number(s2.replace(".", "")) / Math.pow(10, m)
    }
  },
  
  /**
   * 时间格式化
   */
  timeFormat(timestamp, format = 'yyyy-mm-dd hh:MM:ss') {
    if (!timestamp) return ''
    const date = new Date(timestamp * 1000)
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')
    const hours = String(date.getHours()).padStart(2, '0')
    const minutes = String(date.getMinutes()).padStart(2, '0')
    const seconds = String(date.getSeconds()).padStart(2, '0')
    
    return format
      .replace('yyyy', year)
      .replace('mm', month)
      .replace('dd', day)
      .replace('hh', hours)
      .replace('MM', minutes)
      .replace('ss', seconds)
  },
  
  /**
   * 复制到剪贴板
   */
  copyToClipboard(text) {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(text).then(() => {
        return true
      }).catch(() => {
        return false
      })
    } else {
      const textarea = document.createElement('textarea')
      textarea.value = text
      document.body.appendChild(textarea)
      textarea.select()
      document.execCommand('copy')
      document.body.removeChild(textarea)
      return true
    }
  }
}